module.exports = __webpack_public_path__ + "img/blaz-feedback.37461770.png";